export enum Language {
  FINNISH = 'finnish',
  FINLAND_SWEDISH = 'finland-swedish',
  SWEDISH = 'swedish',
  UK_ENGLISH = 'uk-english',
}
